module.exports = __webpack_public_path__ + "static/media/app03_eng.13520a97.png";